import { render, staticRenderFns } from "./specialColumn.vue?vue&type=template&id=3504a2d2&"
import script from "./specialColumn.vue?vue&type=script&lang=js&"
export * from "./specialColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports